const STATIC_MAPS_ENDPOINT = 'https://maps.googleapis.com/maps/api/staticmap';

/**
 * Builds a Google Static Maps URL: one flat image instead of an interactive
 * map. The export used to mount a live GoogleMap per day, wait for its tiles,
 * then hand the PDF service a DOM full of raster tiles to re-download.
 *
 * The map is requested WITHOUT markers: Static Maps cannot render the app's
 * SVG pictos, so ExportStaticMap overlays them in CSS and needs the explicit
 * center/zoom that staticMapView computed (KD-3462).
 *
 * `mapId` applies the same KOOB cloud style as the live maps (KD-3753).
 * Google's DEMO_MAP_ID only exists for the JavaScript API, so it is skipped.
 */
export default function staticMapUrl({
  apiKey,
  size,
  scale = 2,
  center,
  zoom,
  mapId,
}) {
  const params = [
    `size=${encodeURIComponent(size ?? '')}`,
    `scale=${scale}`,
    `key=${encodeURIComponent(apiKey ?? '')}`,
    `center=${center.lat},${center.lon}`,
    `zoom=${zoom}`,
  ];
  if (mapId && mapId !== 'DEMO_MAP_ID') {
    params.push(`map_id=${encodeURIComponent(mapId)}`);
  }

  return `${STATIC_MAPS_ENDPOINT}?${params.join('&')}`;
}
